import axios from "axios";

import { authStore } from "@/store/auth";
import { storeUser } from "@/store/user";

export const commonConfig = {
  // baseUrl: 'http://localhost:8383/api/',
  baseUrl: "/api/",
};

export const api = axios.create({
  baseURL: commonConfig.baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

api.interceptors.request.use(
  (request) => {
    const token = authStore.getToken;

    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${token}`,
    };

    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.log("Неавторизован: токен недействителен или отсутствует");

      authStore.logout();
      storeUser.logout();

      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);
